module.exports = __webpack_public_path__ + "img/188_02.4bb77072.png";